/**
 * @documental
 * @export useInputDisabled
 * @import
 * import { useInputDisabled } from "capitalrx-components-2.0/lib/forms";
 */

import { useDisabled } from "capitalrx-components-2.0/lib/general";
import { InputProps } from "./InputProps";

/**
 * Returns whether the input should be disabled. The `InputGroup`'s `disabled` property only takes into effect if the input
 * does not explicitly have a disabled/enabled state set.
 * @param props The input base properties.
 * @returns Whether the input should be disabled.
 */
export function useInputDisabled(props: InputProps): boolean {
  return useDisabled(props);
}
